import React, { useState } from 'react';
import { colors } from '../../modules/theme';
const layers = [
  {
    id: 'cjys6lgz90aij1co2yi92a8hw',
    name: 'Satellite',
  },

  { id: 'cjynxhqlj350s1dqths5c9s5p', name: 'Dark' },
  { id: 'cjynxg99i1k8e1cpm3ymfb2yh', name: 'Light' },
];
export const isLight = id => layers.find(x => x.id === id).name === 'Light';
const LayerPicker = ({ activeBaseLayerId, onLayerChange }) => {
  const [listOpen, setListOpen] = useState(false);

  const activeLayer = layers.find(l => l.id === activeBaseLayerId);
  const getColor = (isActiveLayer, layer) => {
    if (activeLayer.name === 'Light') {
      return colors.darkBlue;
    }
    return isActiveLayer ? colors.darkBlue : 'white';
  };
  const list = layers.map(x => {
    const isActiveLayer = x.id === activeBaseLayerId;
    return (
      <li
        css={{
          listStyle: 'none',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          marginLeft: 8,
          cursor: 'pointer',
          width: 40,
        }}
        key={x.id}
        onClick={() => onLayerChange(x.id)}
      >
        <div
          css={{
            width: 40,
            height: 40,
            borderRadius: 4,
            overflow: 'hidden',
          }}
        >
          <img
            css={{
              width: 40,
              height: 40,
            }}
            alt={`${x.name} map baselayer`}
            src={`${process.env.URL}/${x.name.toLowerCase()}${
              isActiveLayer ? '-selected' : ''
            }.svg`}
          />
        </div>
        <span
          css={{
            background: isActiveLayer && 'white',
            borderRadius: 8.5,
            height: 18,
            padding: '3px 6px',
            textAlign: 'center',
            fontSize: 12,
            color: getColor(isActiveLayer, x),
            fontWeight: 600,
            marginTop: 8,
            lineHeight: '14px',
          }}
        >
          {x.name}
        </span>
      </li>
    );
  });

  return (
    <div css={{ position: 'relative' }}>
      <button
        css={{
          width: 40,
          height: 40,
          border: 'none',
          borderRadius: 4,
          cursor: 'pointer',
        }}
        onClick={() => setListOpen(x => !x)}
      >
        <img src={process.env.URL + '/layer.svg'} alt="layer" />
      </button>
      <ul
        css={{
          opacity: listOpen ? 1 : 0,
          pointerEvents: listOpen ? 'all' : 'none',
          padding: 0,
          display: 'flex',
          position: 'absolute',
          left: 0,
          top: 0,
          transform: listOpen
            ? 'translateX(calc(-100% - 4px))'
            : 'translateX(calc(-100% + 4px))',
          transition: 'transform 0.3s, opacity 0.2s',
        }}
      >
        {list}
      </ul>
    </div>
  );
};

export default LayerPicker;
